<template>
  <div id="contact" class="site-container">
    <navigation></navigation>

    <iframe title="Contact me"
            height="497"
            allowTransparency="true"
            frameborder="0"
            scrolling="no"
            src="https://j3ca.wufoo.com/embed/q9ea8bd0i9wq3k/">
    </iframe>

    <footer>
      <!--<a href="https://www.instagram.com/jivic_11/" target="_blank">Instagram</a>-->
      <div class="copyright">
        All images &copy; 2018-<span v-text="new Date().getFullYear()"></span> Jovana Ivic
      </div>
    </footer>

  </div>
</template>
<script>
  // @ is an alias to /src
  import Navigation from "../components/Navigation";

  export default {
    name: 'contact',
    components: {Navigation},
    watch: {
      '$route'() {
        window.scrollTo(0, 0);
      }
    },
    data() {
      return {}
    },
    mounted() {
    }
  }
</script>